import { ReactNode } from "react"
import { Box } from "@mui/material"
import type { FCWC } from ".."
import { FilmFestivalFooter, FilmFestivalHeader } from ".."

interface FilmFestivalLayoutProps {
  children: ReactNode
  ready: boolean
  handleOpenTermsModal: () => void
}

const FilmFestivalLayout: FCWC<FilmFestivalLayoutProps> = ({
  children,
  ready,
  handleOpenTermsModal,
}) => {
  return (
    <>
      {ready && (
        <>
          <FilmFestivalHeader />
          <MainContent>{children}</MainContent>
          <FilmFestivalFooter handleOpenTermsModal={handleOpenTermsModal} />
        </>
      )}
    </>
  )
}

export default FilmFestivalLayout

export const MainContent: FCWC = ({ children }) => {
  return (
    <Box
      component="main"
      sx={(theme) => ({
        bgcolor: theme.palette["tertiary.800"].main,
        position: "relative",
        overflow: "hidden",
      })}
    >
      {children}
    </Box>
  )
}
